import React, { useEffect, useState, useRef } from 'react';
import { prop } from 'ramda';
import { useDeviceSelector } from '@core/js/store/hooks';
import { useComponentConfig } from '@core/js/hooks/component/useComponentConfig';

import * as hooks from '@theme/js/components/main/TopWinners/hooks';
import { useUpdateTableHeight } from '@theme/js/components/main/TopWinners/hooks/useUpdateTableHeight';
import * as helpers from '@core/js/components/main/TopWinners/helpers';
import { TableItem } from '@theme/js/components/main/TopWinners/components/Table/components/TableItem';
import { TABLE_ANIMATION_INTERVAL } from '@theme/js/components/main/TopWinners/constants';

import style from '@core/js/components/main/TopWinners/components/Table/Table.scss';

export const Table = () => {
    const isDesktop = useDeviceSelector(prop('isDesktop')); /* Lugano changes */
    const { rowsAmount = 3 } = useComponentConfig();
    const allWinners = hooks.useTopWinners();
    const [tableHeight, setTableHeight] = useState(0);
    const [topWinners] = useState(helpers.getWinnersSelection({
        rowsAmount, startIndex: 0, allWinners
    }));

    /* Lugano changes */
    const [reversedWinners] = useState([...allWinners.reverse()]);
    const [itemHeight, setItemHeight] = useState(0);
    const [transform, setTransform] = useState(0);
    const [startPosition, setStartPosition] = useState(0);
    const elRef = useRef(null);
    const tableItemRef = useRef(null);
    const tableRef = useUpdateTableHeight(topWinners.length, tableItemRef, setTableHeight, setItemHeight);

    useEffect(() => {
        if (tableItemRef?.current) {
            const firstPosition = -itemHeight * allWinners.length;
            setTransform(firstPosition);
            setStartPosition(firstPosition);
        }
    }, [tableItemRef, allWinners, isDesktop, itemHeight]);
    /* Lugano changes */

    useEffect(() => {
        if (!rowsAmount || !itemHeight || !elRef?.current) { /* Lugano changes */
            return;
        }

        const intervalId = setInterval(() => {
            /* Lugano changes */
            setTransform((prev) => {
                if (elRef.current) {
                    elRef.current.style.transitionDuration = '300ms';
                }
                return prev + itemHeight;
            });
            /* Lugano changes */
        }, TABLE_ANIMATION_INTERVAL);

        return () => clearInterval(intervalId);
    }, [allWinners, rowsAmount, elRef, itemHeight]);

    /* Lugano changes */
    useEffect(() => {
        const newPosition = transform + itemHeight;

        if (newPosition > 0) {
            setTimeout(() => {
                if (elRef.current) {
                    elRef.current.style.transitionDuration = '0ms';
                }
                setTransform(startPosition);
            }, 300);
        }
    }, [transform, allWinners, elRef, itemHeight, startPosition]);
    /* Lugano changes */

    /* Lugano changes */
    return (
        <div ref={tableRef} className={`${style.tableWrapper} cms-top-winners-table`}
             style={{ height: `${tableHeight}px`, overflow: 'hidden' }}>
            <div ref={elRef} style={{ transform: `translateY(${transform}px)` }}>
                {topWinners.map((topWinner, index) => (
                    <TableItem
                        {...topWinner}
                        key={`${topWinner.id}${index}`}
                        className={style.topWinner}
                        tableItemRef={index === 0 ? tableItemRef : null}
                    />
                ))}
                {reversedWinners.map((topWinner, index) => (
                    <TableItem
                        {...topWinner}
                        key={topWinner.id}
                        className={style.topWinner}
                        tableItemRef={index === 0 ? tableItemRef : null}
                    />
                ))}
            </div>
        </div>
    );
    /* Lugano changes */
};
